__turbopack_context__.v({
  "body": "SideBySideFloatingImage-module-scss-module__d0ojIa__body",
  "card": "SideBySideFloatingImage-module-scss-module__d0ojIa__card",
  "cardBgAsset": "SideBySideFloatingImage-module-scss-module__d0ojIa__cardBgAsset",
  "cardBody": "SideBySideFloatingImage-module-scss-module__d0ojIa__cardBody",
  "cardContent": "SideBySideFloatingImage-module-scss-module__d0ojIa__cardContent",
  "cardHeadline": "SideBySideFloatingImage-module-scss-module__d0ojIa__cardHeadline",
  "cardOverlay": "SideBySideFloatingImage-module-scss-module__d0ojIa__cardOverlay",
  "collage": "SideBySideFloatingImage-module-scss-module__d0ojIa__collage",
  "cta": "SideBySideFloatingImage-module-scss-module__d0ojIa__cta",
  "floatingAsset": "SideBySideFloatingImage-module-scss-module__d0ojIa__floatingAsset",
  "floatingImage": "SideBySideFloatingImage-module-scss-module__d0ojIa__floatingImage",
  "floatingImageWrapper": "SideBySideFloatingImage-module-scss-module__d0ojIa__floatingImageWrapper",
  "headline": "SideBySideFloatingImage-module-scss-module__d0ojIa__headline",
  "inner": "SideBySideFloatingImage-module-scss-module__d0ojIa__inner",
  "sideBySideFloatingImage": "SideBySideFloatingImage-module-scss-module__d0ojIa__sideBySideFloatingImage",
  "stack-module-0": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-0",
  "stack-module-1": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-1",
  "stack-module-10": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-10",
  "stack-module-11": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-11",
  "stack-module-12": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-12",
  "stack-module-13": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-13",
  "stack-module-14": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-14",
  "stack-module-15": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-15",
  "stack-module-16": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-16",
  "stack-module-17": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-17",
  "stack-module-18": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-18",
  "stack-module-19": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-19",
  "stack-module-2": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-2",
  "stack-module-20": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-20",
  "stack-module-3": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-3",
  "stack-module-4": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-4",
  "stack-module-5": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-5",
  "stack-module-6": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-6",
  "stack-module-7": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-7",
  "stack-module-8": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-8",
  "stack-module-9": "SideBySideFloatingImage-module-scss-module__d0ojIa__stack-module-9",
  "textCol": "SideBySideFloatingImage-module-scss-module__d0ojIa__textCol",
  "z-base": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-base",
  "z-content": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-content",
  "z-footer": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-footer",
  "z-header": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-header",
  "z-hero": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-hero",
  "z-logo": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-logo",
  "z-logo-effect": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-logo-effect",
  "z-navigation": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-navigation",
  "z-sub": "SideBySideFloatingImage-module-scss-module__d0ojIa__z-sub",
});
